import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
 import { Observable, throwError } from 'rxjs';
 import { retry, catchError} from 'rxjs/operators';
import { HttpService } from './service/http.service';
import { CookieService } from 'ngx-cookie-service';
//  import * as CryptoJS from 'crypto-js'
import { environment } from 'src/environments/environment';
import { encryptData } from './shared/ts/utills';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private httpservice: HttpService,private cookieService: CookieService){

  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.setCookies();
    if (!request.url.includes(environment.mySrRedirectUrl) && !request.url.includes(environment.srWaveBaseUrl)) {
      // Add null check for the cookie value
      const cookieValue = localStorage.getItem('cookiie');
      let authReq = request;
      
      if (cookieValue && cookieValue !== 'null') {
        authReq = request.clone({
          headers: request.headers.set('Cookiie', cookieValue)
        });
      }

      return next.handle(authReq).pipe(
        retry(0),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            return this.handleError(error);
          } else {
            return throwError(error);
          }
        })
      );
    }else{
      return next.handle(request.clone()).pipe(
      retry(0),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return this.handleError(error);
        } else {
          return throwError(error);
        }
      })
    );
  }
  }

    async setCookies(){
      let currentDate = Date.now();
  
      const timeStamp = Math.floor(currentDate/1000);
      const cus_device = localStorage.getItem('sys_uuid');
      const ufp = `${cus_device}||${timeStamp}`;
        const encryptionKey= '6fa979f20126cb08aa645a8f495f6d85';
        const encryptionIV= 'I8zyA4lVhMCaJ5Kg';
        // Convert the payload to a string
      const payloadString = JSON.stringify(ufp);
  
        // Encrypt the payload using AES encryption
          // const encryptedPayload = CryptoJS.AES.encrypt(payloadString, CryptoJS.enc.Utf8.parse(encryptionKey), {
          //     iv: CryptoJS.enc.Utf8.parse(encryptionIV),
          //     mode: CryptoJS.mode.CBC,
          //     padding: CryptoJS.pad.Pkcs7,
          // }).toString();
      const encryptedPayload = await encryptData(payloadString, encryptionKey, encryptionIV);
      
        // Encode the encrypted payload in Base64
        // const base64EncodedPayload = btoa(encryptedPayload);
      localStorage.setItem('cookiie',"_ufp=" + btoa(encryptedPayload)+ "; " + document.cookie);
      }

  
  handleError(error: HttpErrorResponse): Observable<any> {
    let errorMessage = ''; 
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`; 
    } else { 
      if(error.status === 401){
        errorMessage = `Error: ${error.error.message}`;
        if(window.location.href.includes("/login?source=sg")){
          localStorage.removeItem("satellizer_token")
          localStorage.removeItem("ngStorage-USER")
        }
        return throwError(errorMessage);
      }
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`; 
    }
    return throwError(errorMessage); 
  }
  getMainDomain() {


    // Split the hostname by dots
    var host = window.location.hostname
    var parts = host.split('.');

    // Check if the hostname has subdomains
    if (parts.length > 2) {
        // Remove the subdomain and return the main domain
        return `.${parts.slice(1).join('.')}`
    }
    else{
      return `.${host}`
    }
}
}